import {
  DRAGGING,
  RUNNING_STATE,
  SAVE_PROPS,
  DRAGGABLE,
  CLONE_MOUNTED,
  PAUSED_ON_FULLSCREEN,
  SET_DEFAULT_MESSAGE,
  CHANGE_MESSAGE,
  CLOSE_MESSAGE,
} from "./types";

export const isTap = boolValue => dispatch =>
  dispatch({
    type: DRAGGING,
    payload: boolValue,
  });

export const carouselPlayHandler = (running, scrolled) => dispatch =>
  dispatch({
    type: RUNNING_STATE,
    payload: {
      running,
      scrolled,
    },
  });

export const saveProps = (position, props) => dispatch => {
  const payload = {};
  payload[position] = props;
  return dispatch({
    type: SAVE_PROPS,
    payload,
  });
};

export const isDraggable = draggable => dispatch =>
  dispatch({
    type: DRAGGABLE,
    payload: draggable,
  });

export const cloneMounted = pos => dispatch =>
  dispatch({
    type: CLONE_MOUNTED,
    payload: pos,
  });

export const pausedOnFullscreen = paused => dispatch =>
  dispatch({
    type: PAUSED_ON_FULLSCREEN,
    payload: paused,
  });

export const setDefaultMessage = defaultMessage => dispatch =>
  dispatch({
    type: SET_DEFAULT_MESSAGE,
    defaultMessage,
  });

export const changeMessage = slideMessage => dispatch =>
  dispatch({
    type: CHANGE_MESSAGE,
    slideMessage,
  });

export const closeMessage = (closed, userOpened) => dispatch =>
  dispatch({
    type: CLOSE_MESSAGE,
    closed,
    userOpened,
  });
